import axios from 'axios'
import moment from 'moment'
import pubsub from 'pubsub-js'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { Link, useParams } from 'react-router-dom'
import Select from 'react-select'
import { Button, FormGroup, Input, Label } from 'reactstrap'
import DateTimeBoostrap from '../../Forms/DateTimeBootstrap'
import { qualityDepartment, retentionDepartments } from './EnumOrder'
import { Card, Checkbox } from '@material-ui/core'
import jwt_decode from 'jwt-decode'
const sectionDescriptions = {
  Authentication: ['Date of Birth', 'PLZ (Postal Code)', 'Billing Form'],
  'Contract Information': [
    'Price',
    'Contract Binding',
    'Monthly Rate (with/ -out Promotion)',
    '(if) additional actions (pricing)',
    '(if) Devices or accessories'
  ],
  'Voice Recording': ['(Wording) - "Were going to record the summary for contract reasons" (continue with the summary)'],
  Summary: [
    'Full Name',
    'Date of Birth',
    'Address',
    'Ordered Products',
    'Prices',
    'Contract Bindings',
    '(Question) Do you understand and agree with the products?'
  ]
}

const OrderForm = ({ user, type, setOrders }) => {
  const history = useHistory()
  const params = useParams()
  const [step, setStep] = useState(1)
  const [loading, setLoading] = useState(false)
  const [ordertypes, setOrdertypes] = useState([])
  const [orderType, setOrderType] = useState('')
  const [order, setOrder] = useState('')
  const [orderOptions, setOrderOptions] = useState([])
  const [orderId, setOrderId] = useState('')
  const [orderActivationDate, setOrderActivationDate] = useState(null)
  const [discountGiven, setDiscountGiven] = useState('')
  const [editMode, setEditMode] = useState(false)
  const [orderUserId, setOrderUserId] = useState()
  const [error, setError] = useState(false)
  const [orderNotFound, setOrderNotFound] = useState(false)
  const [optionsSelected, setOptionsSelected] = useState([])
  const token = localStorage.getItem('token')
  const loggedUserDepartment = user.department[0]
  const isRetentionUser = retentionDepartments.includes(loggedUserDepartment)
  const orderTypeOptions = [
    { label: 'Primare', value: true },
    { label: 'Sekondare', value: false }
  ]

  const discountGivenOptions = [
    { label: '0', value: 0 },
    { label: '5', value: 5 },
    { label: '10', value: 10 },
    { label: '15', value: 15 },
    { label: '20', value: 20 },
    { label: '25', value: 25 }
  ]

  const firstOptionsForm = ['Authentication', 'Contract Information']
  const secondOptionsForm = ['Voice Recording', 'Summary', 'Interaction']
  useEffect(() => {
    if (type == 'edit') {
      setEditMode(true)
    }
  }, [type])

  useEffect(() => {
    const getOrdersType = async () => {
      try {
        const { data } = await axios.get('/ordertype')
        setOrdertypes(data)
      } catch (error) {
        console.log('error', error)
      }
    }

    getOrdersType()
  }, [])

  useEffect(async () => {
    if (orderType) {
      if (ordertypes.success) {
        let allOrderOptions = await ordertypes.data.filter((d) => d.is_primary == orderType?.value)
        const orderOptionsModified = isRetentionUser
          ? allOrderOptions.filter((option) => option.name === 'Retention Save')
          : qualityDepartment.includes(loggedUserDepartment)
            ? allOrderOptions
            : allOrderOptions.filter((option) => option.name !== 'Retention Save')

        setOrderOptions(orderOptionsModified)
      }
    }
  }, [orderType])

  useEffect(async () => {
    if (editMode && ordertypes?.data?.length) {
      let orderId = params.orderId

      try {
        setLoading(true)
        const { data } = await axios.get(`/orders/getOne`, {
          params: { id: orderId }
        })
        if (data.success) {
          let isPrimary = orderTypeOptions.find((orderTypeOption) => orderTypeOption.value == data.order.order_type.is_primary)
          setOrderType(isPrimary)

          let orderOption = ordertypes.data.find((orderOption) => orderOption.name == data.order.order_type.name)
          setOrder(orderOption)

          setOrderId(data.order.order_id)
          setOrderActivationDate(data.order.activation_date)
          setOrderUserId(data.order.user_id._id)
          const discountGivenOption = discountGivenOptions.find((item) => item.value === data.order.discount_given)
          setDiscountGiven(discountGivenOption)
        }
        setLoading(false)
      } catch (e) {
        setLoading(false)
        setOrderNotFound(true)
      }
    }
  }, [editMode, ordertypes])

  if (orderNotFound) {
    return 'ORDER NOT FOUND !'
  }

  const submit = (e) => {
    e.preventDefault()
    setError(false)
    if (orderId && orderType && orderActivationDate && order) {
      let data = {
        id: orderId,
        type: order._id,
        activationDate: new Date(orderActivationDate)
        // discountGiven: discountGiven.value
      }
      if (editMode) {
        data = {
          ...data,
          user_id: orderUserId,
          _id: params.orderId
        }
        axios
          .put('/orders', data)
          .then((data) => {
            if (data.data.success) {
              pubsub.publish('showNotification', {
                message: 'Order updated',
                type: 'success'
              })
              history.goBack()
            }
          })
          .catch((err) => {
            pubsub.publish('showNotification', {
              message: 'Error while updating the order',
              type: 'error'
            })
          })
      } else {
        axios
          .post('/orders', data)
          .then((data) => {
            if (data.data.success) {
              setOrderType('')
              setOrder('')
              setOrderOptions([])
              setOrderId('')
              setOrderActivationDate(null)
              setDiscountGiven({ label: '0', value: 0 })
              setStep(1)
              setOptionsSelected([])
              let order = data.data.order
              if (order) {
                let newOrder = [
                  `${order.user_id.first_name} ${order.user_id.last_name} ${
                    qualityDepartment.includes(order.user_id.department[0]) ? '(From Quality)' : ''
                  }`,
                  order.order_type.name,
                  order.order_type.category?.name || '-',
                  order.order_id,
                  qualityDepartment.includes(order.user_id.department[0]) ? 'Yes' : 'No',
                  order.activation_date ? moment(order.activation_date).format('DD/MM/YYYY') : 'N/A',
                  null,
                  null,
                  // `${order.discount_given}`,
                  <Link to={`/editOrder/${order._id}`}>
                    <Button outline className='mb-1' color='warning' type='button'>
                      <span>Modifiko</span>
                    </Button>
                  </Link>
                ]

                setOrders((prevState) => [newOrder, ...prevState])

                pubsub.publish('showNotification', {
                  message: 'Order Submited',
                  type: 'success'
                })
              }
            }
          })
          .catch((err) => {
            console.log('error', err)
            pubsub.publish('showNotification', {
              message: err,
              type: 'error'
            })
          })
      }
    } else {
      setError(true)
    }
  }

  const deleteOrder = async (id) => {
    try {
      if (user.userLevel == 1 || user.userLevel == 2 || user.userLevel == 1) {
        const { data } = await axios.delete('/orders', {
          params: { id }
        })
        if (data.success) {
          pubsub.publish('showNotification', {
            message: data.message,
            type: 'success'
          })
          history.goBack()
        }
      }
    } catch (e) {
      pubsub.publish('showNotification', {
        message: 'Error while deleting the order',
        type: 'error'
      })
    }
  }

  function handleStepNext(e) {
    if (step === 3) {
      submit(e)
    } else {
      setStep((prev) => prev + 1)
    }
  }
  function handleStepPrev() {
    setStep((prev) => prev - 1)
  }

  function handleOptionCheck(option) {
    if (optionsSelected.includes(option)) {
      setOptionsSelected((prev) => prev.filter((opSel) => opSel !== option))
    } else {
      setOptionsSelected((prev) => [...prev, option])
    }
  }

  function handleValidation() {
    switch (step) {
      case 1:
        return firstOptionsForm.every((item) => optionsSelected.includes(item))
      case 2:
        return secondOptionsForm.every((item) => optionsSelected.includes(item))
      case 3:
        return orderId && orderType && orderActivationDate && order
      // return true

      default:
        return false
    }
  }

  return (
    <div>
      {editMode && (
        <div className='content-heading d-flex justify-content-between'>
          <div>Edit Order</div>
          <div>
            <Button onClick={() => history.goBack()} color='dark'>
              Kthehu prapa
            </Button>
          </div>
        </div>
      )}

      {!loading ? (
        <form onSubmit={(e) => submit(e)}>
          <Card className='p-4 my-3 h-auto z-0' style={{ overflow: 'visible', position: 'relative' }}>
            {!editMode && (
              <div style={{ marginBottom: 20 }}>
                <h4 style={{ marginBottom: 8 }}>Create a New Order</h4>
                <div style={{ color: '#555', fontSize: '1em' }}>
                  Please complete all <b>3 steps</b> to successfully create an order.
                </div>
                <div style={{ color: '#888', fontSize: '0.95em', marginTop: 4 }}>Step {step} of 3</div>
              </div>
            )}

            {step === 1 && !editMode && (
              <div className='space-y-4'>
                {firstOptionsForm.map((item) => {
                  const trimmedItem = item.trim()
                  const id = trimmedItem.toLowerCase().replace(/\s+/g, '')

                  return (
                    <label htmlFor={id} className='flex items-center space-x-2' style={{ cursor: 'pointer', width: '100%' }}>
                      <Checkbox
                        color='primary'
                        id={id}
                        checked={optionsSelected.includes(item)}
                        onChange={() => handleOptionCheck(item)}
                        className='data-[state=checked]:bg-blue-600 data-[state=checked]:text-white'
                      />
                      <span>{item}</span>
                      {sectionDescriptions[item] && (
                        <ul style={{ fontSize: '0.9em', color: '#888', marginBottom: 8 }}>
                          {sectionDescriptions[item].map((desc, idx) => (
                            <li key={idx}>{desc}</li>
                          ))}
                        </ul>
                      )}
                    </label>
                  )
                })}
              </div>
            )}
            {step === 2 && !editMode && (
              <div className='space-y-4'>
                {secondOptionsForm.map((item) => {
                  const id = item.toLowerCase().replace(/\s+/g, '')
                  return (
                    <label htmlFor={id} className='flex items-center space-x-2' style={{ cursor: 'pointer', width: '100%' }}>
                      <Checkbox
                        color='primary'
                        id={id}
                        checked={optionsSelected.includes(item)}
                        onChange={() => handleOptionCheck(item)}
                        className='data-[state=checked]:bg-blue-600 data-[state=checked]:text-white'
                      />
                      <span>{item}</span>
                      {sectionDescriptions[item] && (
                        <ul style={{ fontSize: '0.9em', color: '#888', marginBottom: 8 }}>
                          {sectionDescriptions[item].map((desc, idx) => (
                            <li key={idx}>{desc}</li>
                          ))}
                        </ul>
                      )}
                    </label>
                  )
                })}
              </div>
            )}
            {(step === 3 || editMode) && (
              <div>
                <FormGroup>
                  <Label for='order_type'>Order Type:</Label>
                  <Select
                    placeholder='Selekto Order Type'
                    name='order_type'
                    getOptionValue={(option) => `${option['value']}`}
                    value={orderType}
                    options={orderTypeOptions}
                    onChange={setOrderType}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for='order'>Order:</Label>
                  <Select
                    placeholder='Selekto Order'
                    name='order'
                    getOptionLabel={(option) => option['name']}
                    getOptionValue={(option) => option['_id']}
                    value={order}
                    options={orderOptions}
                    onChange={setOrder}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for='order_id'>Order ID:</Label>
                  <Input
                    type='text'
                    name='order_id'
                    id='order_id'
                    placeholder='Shkruaj ID e Orderit'
                    onChange={(e) => setOrderId(e.target.value)}
                    value={orderId}
                    data-validate='["required"]'
                  />
                </FormGroup>

                <FormGroup>
                  <Label for='orderActivationDate'>Order activation date:</Label>
                  <DateTimeBoostrap
                    value={moment(orderActivationDate).format('DD/MM/YYYY')}
                    dateFormat={'DD/MM/YYYY'}
                    timeFormat=''
                    onChange={(e) => setOrderActivationDate(e._d)}
                  />
                </FormGroup>
              </div>
            )}

            {error && (
              <div className='mb-2'>
                <span className='text-danger'>Ju lutem plotesoni te gjitha fushat !</span>
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: editMode ? '' : 'space-between', padding: 10 }}>
              {!editMode && (
                <Button disabled={step === 1} onClick={() => handleStepPrev()}>
                  Previous
                </Button>
              )}

              <Button
                onClick={handleStepNext}
                type={editMode ? 'submit' : 'button'}
                disabled={!editMode && !handleValidation()}
                style={{ backgroundColor: step === 3 ? '#32CD32' : '#1E90FF', color: '#fff' }}
              >
                {step === 3 ? 'Submit' : editMode ? 'Edit' : 'Next'}
              </Button>

              {(user?.userLevel == 1 || user?.userLevel == 2 || user?.userLevel == 3) && editMode ? (
                <Button onClick={() => deleteOrder(params.orderId)} color='danger' className='btn-oval ml-2'>
                  Delete Order
                </Button>
              ) : (
                ''
              )}
            </div>
          </Card>
        </form>
      ) : (
        'Loading...'
      )}
    </div>
  )
}

export default OrderForm
